import { Divider, Grid, Box } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Button from "../../../components/common/Button";
import OrganizationStructure from "../../../components/common/OrganizationStructure/OrganizationStructure";
import Toast from "../../../components/common/Toast";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { handleValidation } from "../../../utils";
import { debounce } from "../../../utils/helper";
import CreateIntroductionForm from "./CreateIntroductionForm/CreateIntroductionForm";
import { NEW_ENTRY_FIELDS } from "./CreateIntroductionForm/formFields";

const prepareValues = (values) => {
  const newValues = { ...values };
  // OLD (kept for future reference): submitted raw values without trimming.
  // return values;
  if (newValues.emailId) {
    newValues.emailId = String(newValues.emailId).trim();
  }
  if (newValues.introducerEmail) {
    newValues.introducerEmail = String(newValues.introducerEmail).trim();
  }
  if ("introducedBy" in newValues) {
    if (newValues?.introducedBy) {
      return newValues;
    }
    delete newValues.introducedBy;
    return newValues;
  }
  return newValues;
};

function CreateIntroduction() {
  const TITLE = "Create Introduction - BSG";
  const [showToast, setShowToast] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const onBack = () => navigate(-1);

  const postData = async (values) => {
    try {
      setIsLoading(true);
      const response = await IntroductionFormApi.postIntroductions({
        data: values,
      });
      setTimeout(() => {
        navigate("/introduction/view");
      }, 2000);
      if (response) {
        setShowToast({
          message: "Form submitted successfully",
          severity: "success",
        });
      }
      setIsLoading(false);
    } catch (err) {
      setShowToast({ message: err.message, severity: "error" });
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Grid container>
        <Formik
          initialValues={{}}
          onSubmit={debounce((values) => {
            const result = handleValidation(NEW_ENTRY_FIELDS, values);
            if (result && Object.keys(result).length) {
              setShowToast(result);
              return;
            }
            const newValues = prepareValues(values);
            postData(newValues);
          })}
        >
          {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
            <>
              <Box display="flex" gap="30px">
                <Grid item md={8} sm={12}>
                  <CreateIntroductionForm
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
                <Grid item md={4} sm={12}>
                  <OrganizationStructure
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    isLoading={isLoading}
                  />
                </Grid>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  width: "100%",
                  paddingTop: "1%",
                  marginBottom: "30px",
                }}
              />
              <div style={{ display: "flex", gap: 5 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  // style={CommonStyles.buttonStyle}
                  label="Submit"
                  type="submit"
                />
                <Button
                  variant="outlined"
                  onClick={onBack}
                  label="Cancel"
                  disabled={isLoading}
                  style={{
                    // ...CommonStyles.buttonStyle,
                    marginLeft: "20px",
                  }}
                />
              </div>
            </>
          )}
        </Formik>
      </Grid>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </>
  );
}

export default CreateIntroduction;
